module.exports = __webpack_public_path__ + "img/ok-icon.2063c80e.svg";